import React, { useEffect, useContext, useState } from 'react'
import RadioBox from '@/product/components/atoms/RadioBox'
import { useFormik } from 'formik'
import { mapData, dateFormatFunction } from '@/product/common/components'
import ReportDisplay from '@/views/Report/display'
import { useHistory } from 'react-router-dom'
import CheckBox from '@/product/components/atoms/CheckBox'
import AuthContext from '@/product/context/auth/authContext'
import { useTranslation } from 'react-i18next'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import ReportContext from '@/custom/context/report/reportContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AuctionContext from '@/product/context/auction/auctionContext'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import AlertContext from '@/product/context/alert/alertContext'
import SettingContext from '@/product/context/setting/settingContext'
import UserContext from '@/product/context/user/userContext'

const ReportComponent = (props) => {
    const history = useHistory()
    const { t } = useTranslation()
    const { setAlert } = useContext(AlertContext)
    const reportContext = useContext(ReportContext)
    const auctionContext = useContext(AuctionContext)
    const [resetForm, setResetForm] = React.useState(false)
    const [reportsData, setReportsData] = React.useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const { allBusinessCategory } = useContext(CustomCommonContext)
    const { all_auctions, getAllAuctions } = auctionContext
    const [report, setReport] = React.useState(null)
    const [isTemplate, setIsTemplate] = React.useState(true)
    const [templateId, setTemplateId] = useState(0)
    const [reportName, setReportName] = React.useState('')
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const settingcontext = useContext(SettingContext)
    const userContext = useContext(UserContext)
    const { single_user } = userContext
    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const {
        reports_data,
        report_templates,
        getAllReportDisplay,
        getAllReportDownload,
        reportTemplateAction,
        responseStatus: responseStatusReport,
        clearResponse: clearResponseReport,
        getAllReportTemplates,
        deleteReportTemplate,
    } = reportContext

    const [manage, setManage] = React.useState({
        popup: false,
    })
    const [reportType, setReportType] = React.useState('')

    const toggleFullScreenPopup = (popup) => {
        setManage({ popup: popup })
    }

    const [tableBody, setTableBody] = useState([])

    const formikAuction = useFormik({
        initialValues: {
            limit: 10,
            page: 1,
            orderby: '',
            order: '',
            auctionFetch: props.auctionFetch || false,
            filters: {
                active: {
                    type: 'in',
                    field: 'ac.market_status',
                    value: 'closed',
                },
            },
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            getAllAuctions(values, 'reportsAuction')
        },
    })
    const [dataFilterFields, setDataFilterFields] = useState([])
    const [sortColumFieldFilter, setSortColumFieldFilter] = useState([])

    useEffect(() => {
        if (all_auctions && all_auctions.from === 'reportsAuction') {
            let dataNew = all_auctions.records.map((opt) => {
                let updatedObject = {}
                updatedObject.value = opt.id
                updatedObject.show = `${opt.title} (${opt.id})`
                return updatedObject
            })
            setTableBody(dataNew)
        }
        setIsLoading(false)
    }, [all_auctions])

    const formik = useFormik({
        initialValues: {
            ...props.initialValues,
            single_date: dateFormatFunction(new Date()),
            live_total_bid_met: false,
            live_total_bid: false,
        },
        validateOnBlur: false,
        validationSchema: props.validationSchema,
        onSubmit: (values) => {
            setIsLoading(true)
            values.page = props.initialValues?.page || 1
            values.limit = props.initialValues?.limt || 20
            values.replaceName = props.replaceName ? props.replaceName : {}
            values.joinBuynow = true
            if (props.specific_seller) {
                if (
                    user &&
                    user.emp_type !== 'super_admin' &&
                    user.admin_id > 0 &&
                    values.report == 'sold_order'
                ) {
                    values.filters = values.filters
                        ? {
                              ...values.filters,
                              specific_seller: {
                                  value: user.admin_id,
                                  type: 'in',
                                  field: 'p.user_id',
                              },
                          }
                        : {
                              specific_seller: {
                                  value: user.admin_id,
                                  type: 'in',
                                  field: 'p.user_id',
                              },
                          }
                }
            }

            values.report =
                values.template_name == 'Transaction Reconciliation'
                    ? values.report
                    : reportName
                    ? reportName
                    : values.report
            let auction = values?.filters?.auctionid?.value
                ? values.filters.auctionid.value
                : ''
            values.downloadTitle =
                values.report === 'closed_auction_completion_report'
                    ? `Auction Report -${auction}`
                    : null
            if (
                props.agencyFilter &&
                user?.emp_type !== 'super_admin' &&
                filteredAgencies.length &&
                agencyReports.includes(values.report)
            ) {
                if (formik.values?.filters?.agency_id?.value.length <= 0) {
                    setAlert('Please Select Agency', 'error')
                    return false
                }
            }
            if (values.template) {
                reportTemplateAction(values)
                formik.values.template = false
                //setGenerateReport(false)
                return false
            }

            if (
                props.customField &&
                props.customField.includes(values.report) &&
                values.action === 'download'
            ) {
                let formFields = props.formFields
                let fieldsToSend = formFields
                fieldsToSend = fieldsToSend.filter(
                    (field) =>
                        field.group.indexOf(values.report.toString()) !== -1
                )
                fieldsToSend = fieldsToSend.filter((field) =>
                    values.fields.includes(field.field)
                )
                let changedValues = { ...values, fields: fieldsToSend }
                formik.setSubmitting(true)
                getAllReportDownload(changedValues)
            } else {
                formik.setSubmitting(true)
                const dropDownFields = props.dropDownFields
                values.dropDownFields = dropDownFields
                if (values.action === 'display') {
                    getAllReportDisplay(values)
                    toggleFullScreenPopup(true)
                } else {
                    getAllReportDownload(values)
                }
            }
        },
    })

    useEffect(() => {
        toggleFullScreenPopup(false)
        setResetForm(!resetForm)
        setReportsData(null)
        getAllReportTemplates()
    }, [])

    useEffect(() => {
        if (responseStatusReport) {
            if (responseStatusReport.from === 'createTemplate') {
                if (responseStatusReport.status === 'success') {
                    setAlert('Updated Successfully', 'success')

                    formik.values.within = 'day'

                    formik.values.template_name = ''
                    formik.values.search = 'within'
                    formik.values.select_type = 'single_date'
                    formik.values.template = false
                    formik.values.report = 'active_user_management'
                    getAllReportTemplates()
                }
            } else if (responseStatusReport.from === 'deleteReportTemplate') {
                if (responseStatusReport.status === 'success') {
                    setAlert('Deleted Successfully', 'success')
                    formik.values.within = 'day'
                    formik.values.template_name = ''
                    formik.values.template = false
                    formik.values.template = ''
                    formik.values.search = 'within'
                    formik.values.select_type = 'single_date'
                    formik.values.report = 'active_user_management'
                    getAllReportTemplates()
                }
            }
            if (responseStatusReport.from === 'updateTemplate') {
                if (responseStatusReport.status === 'success') {
                    setAlert('Updated Successfully', 'success')
                    getAllReportTemplates()
                }
            }
        }
        clearResponseReport()
    }, [responseStatusReport])

    useEffect(() => {
        if (report_templates && report_templates.length) {
            const optionArr = report_templates.map((subcat) => {
                let subCategoryChanged = {}
                subCategoryChanged.show = subcat.template_name
                subCategoryChanged.value = subcat.report_name
                return subCategoryChanged
            })
            let customTemplates = {
                head: 'Custom Templates',
                options: optionArr,
            }

            const foundObject = props.report.data[0].groupoptions.find(
                (obj) => obj.head === 'Custom Templates'
            )
            if (foundObject) {
                foundObject.options = optionArr
            } else {
                props.report.data[0].groupoptions.unshift(customTemplates)
            }

            setReport(props.report ? { formik: formik, ...props.report } : {})
        } else {
            props.report.data[0].groupoptions =
                props.report.data[0].groupoptions.filter(
                    (obj) => obj.head != 'Custom Templates'
                )
            setReport(props.report ? { formik: formik, ...props.report } : {})
        }
    }, [report_templates, props.report])

    useEffect(() => {
        if (reports_data) {
            setReportsData(reports_data)

            setIsLoading(false)
            // toggleFullScreenPopup(true)
        }
    }, [reports_data])

    useEffect(() => {
        if (
            formik.values.report === 'single_auction_product_management' ||
            formik.values.report === 'all_auction_bid_history_reports' ||
            formik.values.report === 'closed_auction_completion_report'
        ) {
            formikAuction.submitForm()
        } else {
            if (formik.values?.filters?.auctionid?.value) {
                formik.values.filters.auctionid.value = ''
            }
        }
    }, [formik.values.report])

    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    })

    useEffect(() => {
        props.additionalfieldUpdate(formik.values)
    }, [formik.values])

    const allSortOptions = [
        { id: 'asc', description: 'Ascending' },
        { id: 'desc', description: 'Descending' },
    ]

    const allSearchOptions = props.allSearchOptions

    const action = [
        {
            label: t('Action'),
            placeholder: t('Select Report Type'),
            class: 'col-12',
            type: 'select',
            options: [
                { value: 'display', show: 'Display' },
                { value: 'download', show: 'Download' },
            ],
            name: 'action',
            formik: formik,
        },
    ]

    const template = [
        {
            label: t('Template Name'),
            placeholder: t('Enter Tempalte Name'),
            class: `${formik.values.template ? '' : ''} col-sm-6 col-12`,
            type: '',

            name: 'template_name',
            formik: formik,
        },
    ]

    const withinRange = [
        {
            label: t('Within'),
            placeholder: t('Enter Within'),
            class: 'col-12',
            type: 'select',
            options: [
                { value: 'day', show: t('The Past Day') },
                { value: 'week', show: t('The Past Week') },
                { value: 'month', show: t('The Past Month') },
                { value: 'year', show: t('The Past Year') },
            ],
            name: 'within',
            formik: formik,
        },
    ]
    const optionFunc = (data) => {
        const op = {
            limit: 25,
            page: 1,
            orderby: '',
            order: '',
            auctionFetch: props.auctionFetch || false,
            filters: {
                active: {
                    type: 'in',
                    field: 'ac.market_status',
                    value: 'closed',
                },
                data: {
                    type: 'like',
                    field: 'ac.id,ac.title',
                    value: data,
                },
            },
        }
        getAllAuctions(op, 'reportsAuction')
    }

    useEffect(() => {
        if (formik?.values?.fields) {
            let sortcolumFields = formik?.values?.fields.map((el) => ({
                value: el,
                show: el,
            }))
            setSortColumFieldFilter(sortcolumFields)
        }
    }, [formik?.values?.fields])

    const auctionRange = {
        formik: formik,
        data: [
            // {
            //     label: 'Enable Staggered',
            //     placeholder: 'Enable Staggered Bidding',
            //     type: 'checkbox',
            //     class: 'col-12',
            //     name: 'ending_enable',
            //     formik: formik,
            // },
            {
                label: t('Buyer ID/Name'),
                placeholder: t('Enter Buyer ID/Name'),
                type: 'text',

                class: `col-6`,
                // options: tableBody,
                name: 'buyer',
                filter: true,
            },
            {
                label: t('Seller ID/Name'),
                placeholder: t('Enter Seller ID/Name'),
                type: 'text',

                class: `col-6`,
                // options: tableBody,
                name: 'seller',
                filter: true,
            },
            {
                label: t('Transaction ID'),
                placeholder: t('Enter Transaction ID'),
                type: 'text',

                class: `col-6`,
                // options: tableBody,
                name: 'transaction',
                filter: true,
            },
            {
                label: t('Product ID'),
                placeholder: t('Enter Product ID'),
                type: 'text',

                class: `col-6`,
                // options: tableBody,
                name: 'product',
                filter: true,
            },
            // {
            //     label: t('Auction'),
            //     placeholder: t('Select Auction'),
            //     type: 'select',
            //     class: `col-12`,
            //     options: tableBody?.map((opt) => {
            //         let updatedObject = {}
            //         updatedObject.value = opt.id
            //         updatedObject.show = `${opt.title} (${opt.id})`
            //         return updatedObject
            //     }),
            //     name: 'auctionid',
            //     filter: true,
            // },
        ],
    }

    const sortSelect = {
        formik: formik,
        data: [
            {
                label: 'Sort colum1 field',
                type: 'select',
                isNoDefaultOptionValue: true,
                class: 'col-3',
                placeholder: 'Sort colum1',
                name: 'orderby',
                options: sortColumFieldFilter,
            },
            {
                label: 'Sort 1',
                type: 'select',
                isNoDefaultOptionValue: true,
                placeholder: 'Sort 1',
                class: 'col-3',
                name: 'order',
                options: [
                    { value: 'asc', show: 'Ascending' },
                    { value: 'desc', show: 'Descending' },
                ],
            },
            {
                label: 'Sort colum2 field',
                type: 'select',
                isNoDefaultOptionValue: true,
                placeholder: 'Sort colum2 field',
                class: 'col-3',
                name: 'orderby2',
                options: sortColumFieldFilter,
            },
            {
                label: 'Sort2',
                type: 'select',
                isNoDefaultOptionValue: true,
                placeholder: 'Sort2',
                size: 'small',
                class: 'col-3',
                name: 'order2',
                options: [
                    { value: 'asc', show: 'Ascending' },
                    { value: 'desc', show: 'Descending' },
                ],
            },
        ],
    }

    const reportNameField = {
        formik: formik,
        data: [
            {
                label: 'Report',
                type: 'text',
                class: 'col-7',
                placeholder: 'report title',
                name: 'report_heading',
            },
            {
                label: 'Export to File',
                type: 'text',
                class: 'col-7',
                placeholder: 'export to file',
                name: 'export_filename',
            },
        ],
    }

    // const report = props.report ? { formik: formik, ...props.report } : {}
    const today = new Date()
    const currentYear = today.getFullYear()

    const dateRange = {
        formik: formik,
        data: [
            {
                label: t('Select Type'),
                placeholder: t('Select Type'),
                class: 'col',
                type: 'select',
                name: 'select_type',
                options: [
                    { value: 'single_date', show: t('Date') },
                    { value: 'date', show: t('Date Range') },
                    { value: 'yearly', show: t('Yearly') },
                    { value: 'quarterly', show: t('Quarterly') },
                    { value: 'monthly', show: t('Monthly') },
                ],
            },
            {
                label: t('Select Quarter'),
                placeholder: t('Select Quarter'),
                class: ` ${
                    formik.values?.select_type === 'quarterly' ? '' : 'd-none'
                } col-4 `,
                type: 'select',
                name: 'quarterly',
                options: [
                    { value: 'q1', show: t('Q1') },
                    { value: 'q2', show: t('Q2') },
                    { value: 'q3', show: t('Q3') },
                    { value: 'q4', show: t('Q4') },
                ],
            },
            {
                label: t('Select Month'),
                placeholder: t('Select Month'),
                class: ` ${
                    formik.values?.select_type === 'monthly' ? '' : 'd-none'
                } col-4 `,
                type: 'select',
                name: 'month',
                options: [
                    { value: '', show: t('Select Month') },
                    { value: '01', show: 'January' },
                    { value: '02', show: 'February' },
                    { value: '03', show: 'March' },
                    { value: '04', show: 'April' },
                    { value: '05', show: 'May' },
                    { value: '06', show: 'June' },
                    { value: '07', show: 'July' },
                    { value: '08', show: 'August' },
                    { value: '09', show: 'September' },
                    { value: '10', show: 'October' },
                    { value: '11', show: 'November' },
                    { value: '12', show: 'December' },
                ],
            },
            {
                label: t('Select Year'),
                placeholder: t('Select Year'),
                class: ` ${
                    formik.values?.select_type === 'monthly' ||
                    formik.values?.select_type === 'yearly' ||
                    formik.values?.select_type === 'quarterly'
                        ? ''
                        : 'd-none'
                } col-4 `,
                type: 'select',
                disabled: formik.values?.month !== '' ? false : true,
                name: 'year',
                options: [
                    { value: '', show: t('Select Year') },
                    { value: `${currentYear}`, show: `${currentYear}` },
                    { value: `${currentYear - 1}`, show: `${currentYear - 1}` },
                    { value: `${currentYear - 2}`, show: `${currentYear - 2}` },
                    { value: `${currentYear - 3}`, show: `${currentYear - 3}` },
                    { value: `${currentYear - 4}`, show: `${currentYear - 4}` },
                    { value: `${currentYear - 5}`, show: `${currentYear - 5}` },
                ],
            },
            {
                label: t('Date'),
                placeholder: t('Enter Date'),
                type: 'date',
                class: `customDateReport ${
                    formik.values?.select_type === 'single_date' ? '' : 'd-none'
                } col-auto `,
                name: 'single_date',
                disableFuture: true,
            },
            {
                label: t('From Date'),
                placeholder: t('Enter From date'),
                type: 'date',
                class: ` ${
                    formik.values?.select_type === 'date' ? '' : 'd-none'
                } col-4 `,
                name: 'start_date',
            },
            {
                label: t('End date'),
                placeholder: t('Enter End date'),
                type: 'date',
                class: ` ${
                    formik.values?.select_type === 'date' ? '' : 'd-none'
                } col-4 `,
                name: 'end_date',
            },
        ],
    }

    useEffect(() => {
        let selectValue = formik.values?.select_type
        if (selectValue) {
            if (selectValue === 'quarterly') {
                let quarterlyValue = formik.values?.quarterly
                let yearValue = formik.values?.year
                if (quarterlyValue !== '') {
                    if (!yearValue) {
                        const today = new Date()
                        const currentYear = today.getFullYear()
                        yearValue = currentYear
                    }
                    if (quarterlyValue === 'q1') {
                        formik.values.start_date = `01-01-${yearValue}`
                        formik.values.end_date = `03-31-${yearValue}`
                    } else if (quarterlyValue === 'q2') {
                        formik.values.start_date = `04-01-${yearValue}`
                        formik.values.end_date = `06-30-${yearValue}`
                    } else if (quarterlyValue === 'q3') {
                        formik.values.start_date = `07-01-${yearValue}`
                        formik.values.end_date = `09-30-${yearValue}`
                    } else if (quarterlyValue === 'q4') {
                        formik.values.start_date = `10-01-${yearValue}`
                        formik.values.end_date = `12-31-${yearValue}`
                    }
                }
            } else if (selectValue === 'yearly') {
                let yearValue = formik.values?.year
                if (yearValue && yearValue !== '') {
                    formik.values.start_date = `01-01-${yearValue}`
                    formik.values.end_date = `12-31-${yearValue}`
                }
            } else if (selectValue === 'monthly') {
                let monthValue = formik.values?.month
                let yearValue = formik.values?.year
                if (monthValue && monthValue !== '') {
                    let month = parseInt(monthValue)
                    let finalmonth = monthValue
                    const today = new Date()
                    const currentYear = today.getFullYear()

                    const lastDay = new Date(currentYear, month, 0).getDate()
                    const endDate = new Date(
                        currentYear,
                        month - 1,
                        lastDay
                    ).getDate()

                    if (yearValue !== '') {
                        formik.values.start_date = `${finalmonth}-01-${yearValue}`
                        formik.values.end_date = `${finalmonth}-${endDate}-${yearValue}`
                    } else {
                        formik.values.start_date = `${finalmonth}-01-${currentYear}`
                        formik.values.end_date = `${finalmonth}-${endDate}-${currentYear}`
                    }
                }
            }
        }
    }, [
        formik.values?.select_type,
        formik.values?.month,
        formik.values?.year,
        formik.values?.quarterly,
    ])

    const limitResult = props.limitResult
        ? { formik: formik, ...props.limitResult }
        : {}

    let formFields = props.formFields
    useEffect(() => {
        if (formik.values.report) {
            if (typeof props.dynamicSelect === 'function')
                props.dynamicSelect(3, formik.values.report)
        }
    }, [formik.values.report])

    useEffect(() => {
        if (formik.values.report) {
            let selectedTemplate
            if (report_templates && report_templates.length) {
                selectedTemplate = report_templates.find(
                    (ele) => ele.report_name === formik.values.report
                )
            }

            if (selectedTemplate && Object.keys(selectedTemplate).length) {
                setTemplateId(selectedTemplate.id)
                setReportName(selectedTemplate.report_name)
                const string = selectedTemplate.additional_fields
                const obj = JSON.parse(string)
                formik.values.filters = obj.filters
                formik.values.fields = JSON.parse(selectedTemplate.fields)
                    ? JSON.parse(selectedTemplate.fields)
                    : []

                formik.values.template_name = selectedTemplate.template_name

                formik.values.search =
                    selectedTemplate.search == 0 ? 'within' : 'customSelection'
                formik.values.within =
                    selectedTemplate.search == 0
                        ? selectedTemplate.search_type
                        : ''
                formik.values.select_type =
                    selectedTemplate.search == 1
                        ? selectedTemplate.search_type
                        : ''
                formik.values.page = 1
                formik.values.order =
                    selectedTemplate.sort == 0 ? 'asc' : 'desc'
                formik.values.orderby = ''
                formik.values.searchterm = ''
                setIsTemplate(false)
            } else {
                formik.values.order = 'asc'
                formik.values.within = 'day'
                formik.values.search = 'within'
                formik.values.select_type = 'single_date'
            }

            if (typeof props.dynamicSelect === 'function')
                props.dynamicSelect(3, formik.values.report)
        }
    }, [formik.values.report])

    useEffect(() => {
        if (formik.values.report) {
            let selectedTemplate
            if (report_templates && report_templates.length) {
                selectedTemplate = report_templates.find(
                    (ele) => ele.report_name === formik.values.report
                )
            }

            if (selectedTemplate && Object.keys(selectedTemplate).length) {
                setTemplateId(selectedTemplate.id)
                setReportName(selectedTemplate.report_name)
                const string = selectedTemplate.additional_fields
                const obj = JSON.parse(string)
                formik.values.filters = obj.filters

                formik.values.fields = formik.values.fields
                // formik.values.fields = JSON.parse(selectedTemplate.fields)
                //     ? JSON.parse(selectedTemplate.fields)
                //     : []
                formik.values.template_name = formik.values.template_name
                formik.values.template = formik.values.template
                formik.values.search = formik.values.search

                formik.values.within = formik.values.within

                formik.values.select_type = formik.values.select_type

                formik.values.page = 1
                formik.values.order = formik.values.order
                formik.values.orderby = ''
                formik.values.searchterm = ''
                setIsTemplate(false)
                if (formik.values.report !== reportType) {
                    // formik.values.fields = valueSelected
                    setReportType(formik.values.report)
                }
            } else if (
                formik.values.report === 'closed_auction_completion_report' &&
                formFields[0]?.title
            ) {
                formik.values.page = 1
                formik.values.order = formik.values?.order
                    ? formik.values.order
                    : 'asc'
                formik.values.orderby = ''
                formik.values.searchterm = ''
                setReportName(formik.values.report)
                setTemplateId(0)
                let valueSelected = []
                // let valueSelectedId = []
                let fieldsToSort = formFields

                fieldsToSort?.map((item) =>
                    item?.formFields
                        .filter(
                            (field) =>
                                field?.group?.indexOf(
                                    formik.values?.report.toString()
                                ) !== -1
                        )
                        .map((d, i) => {
                            valueSelected.push(d.field)
                            // valueSelectedId.push(d.field)
                        })
                )

                formik.values.fields = valueSelected
                // formik.values.fields = valueSelectedId

                setResetForm(!resetForm)
                setReportsData(null)
                setIsTemplate(true)
            } else {
                formik.values.page = 1
                formik.values.order = formik.values?.order
                    ? formik.values.order
                    : 'asc'
                formik.values.orderby = ''
                formik.values.searchterm = ''
                formik.values.within = formik.values.within
                setReportName(formik.values.report)
                setTemplateId(0)
                let valueSelected = []
                let fieldsToSort = formFields
                fieldsToSort
                    ?.filter(
                        (field) =>
                            field?.group?.indexOf(
                                formik.values?.report.toString()
                            ) !== -1
                    )
                    .map((d, i) => valueSelected.push(d.field))

                if (formik.values.report !== reportType) {
                    formik.values.fields = valueSelected
                    setReportType(formik.values.report)
                }

                setResetForm(!resetForm)
                setReportsData(null)
                setIsTemplate(true)
            }
        }
        return () => {
            setReportsData(null)
        }
    }, [formik.values.report, props.isLoading, props.formFields])

    const updateTemplate = () => {
        const values = formik.values
        const selectedTemplate = report_templates.find(
            (ele) => ele.report_name === formik.values.report
        )
        values.id = selectedTemplate.id

        values.report = reportName ? reportName : values.report

        values.template = true
        reportTemplateAction(values, 'updateTemplate')
    }

    const generateReport = (data) => {
        if (data === 'template') {
            formik.values.template = true
        } else {
            formik.values.template = false
        }

        formik.handleSubmit()
    }

    let dataFilterId = []

    const handleDataFilterFields = (el) => {
        if (
            dataFilterFields.length > 0 &&
            dataFilterFields.some((item) => item?.id === el.id)
        ) {
            formik.setFieldValue(`filters.${el.name}`, '')
            dataFilterId = dataFilterFields.filter((item) => item.id !== el.id)
            setDataFilterFields(dataFilterId)
        } else {
            // If the element does not exist, add it

            // dataFilterId.push(el)
            setDataFilterFields([...dataFilterFields, el])
        }
    }

    return (
        <div className="dashboard reportManagement">
            <ReportDisplay
                formik={formik}
                fieldsToShow={formFields}
                searchInfo={props.searchInfo}
                top_api_heading={props.top_api_heading}
                data={manage}
                function={toggleFullScreenPopup}
                hideCompactView={props.hideCompactView}
            />
            <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                <h6 className="dashSubtitle">
                    {t(
                        'Report management gives you direct access of accounting overview based on the reporting you wish to formulate.'
                    )}
                </h6>
                <div className="reportAction d-flex align-items-center">
                    <div className="row">{Object.values(mapData(action))}</div>
                </div>
                {report ? (
                    <div className="reportAction d-flex align-items-center">
                        <div className="row">
                            {Object.values(mapData(report))}
                        </div>
                    </div>
                ) : null}{' '}
                {props.additionalMapData ? (
                    <div className="reportAction d-flex align-items-center">
                        <div className="row">
                            {mapData({ formik, data: props.additionalMapData })}
                        </div>
                    </div>
                ) : null}
                <h6 className="dashSubtitle">
                    {props.customLabel ? props.customLabel : ''}
                </h6>
                {formik?.values?.report ===
                'closed_auction_completion_report' ? (
                    formFields?.map((item) => {
                        return (
                            <div className="reportAction d-flex align-items-center flex-wrap">
                                <div className="reportLabel mb-2">
                                    <h6>{item?.title}</h6>
                                </div>

                                <div className="reportFields d-flex justify-content-start align-items-center flex-wrap">
                                    {item?.formFields
                                        ?.filter(
                                            (field) =>
                                                field?.group?.indexOf(
                                                    reportName
                                                        ? reportName
                                                        : formik.values.report.toString()
                                                ) !== -1
                                        )
                                        .map((d, i) => (
                                            <>
                                                <CheckBox
                                                    name="fields"
                                                    label={d?.label}
                                                    checked={
                                                        formik?.values?.fields?.indexOf(
                                                            d?.field?.toString()
                                                        ) !== -1
                                                            ? true
                                                            : false
                                                    }
                                                    value={d.field}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                />
                                            </>
                                        ))}
                                </div>
                            </div>
                        )
                    })
                ) : (
                    <div className="reportAction d-flex align-items-center flex-wrap">
                        <div className="reportLabel">
                            <h6>{t('Fields')}</h6>
                        </div>

                        <div className="reportFields d-flex justify-content-start align-items-center flex-wrap">
                            {formFields
                                .filter(
                                    (field) =>
                                        field?.group?.indexOf(
                                            reportName
                                                ? reportName
                                                : formik.values.report.toString()
                                        ) !== -1
                                )
                                .map((d, i) => (
                                    <>
                                        <CheckBox
                                            name="fields"
                                            label={d?.label}
                                            checked={
                                                formik?.values?.fields?.indexOf(
                                                    d?.field?.toString()
                                                ) !== -1
                                                    ? true
                                                    : false
                                            }
                                            value={d.field?.toString()}
                                            onChange={formik.handleChange}
                                        />
                                    </>
                                ))}
                        </div>
                    </div>
                )}
                {formik.values.report ==
                'transaction_reconcile_transaction_reconciliation' ? (
                    <PrimaryButton
                        id="report_add"
                        onClick={() => {
                            updateTemplate()
                        }}
                        btnSize="ml-2"
                        // type="submit"
                        label={'Save Preference'}
                    />
                ) : null}{' '}
                {formik?.values?.report ===
                    'closed_auction_completion_report' && (
                    <>
                        {' '}
                        <div className="reportAction d-flex align-items-center flex-wrap">
                            <div className="reportLabel mb-2">
                                <h6>Data Filter</h6>
                            </div>
                        </div>
                        <div className="reportFields d-flex justify-content-start align-items-center flex-wrap">
                            {props?.auctionFilter?.data?.map((item) => {
                                return (
                                    // <div className="reportFields col-3">
                                    <>
                                        <CheckBox
                                            name="fields"
                                            label={item?.label}
                                            value={item.id}
                                            onChange={(e) =>
                                                handleDataFilterFields(item)
                                            }
                                        />
                                    </>
                                    // </div>
                                )
                            })}
                        </div>
                        <div className="reportAction d-flex align-items-center flex-wrap">
                            <div className="reportLabel mb-2">
                                <h6>Settings</h6>
                            </div>
                        </div>
                        <div className="d-flex align-items-center flex-wrap">
                            <h6>EmployeeId : </h6> <h6> {user?.admin_id} </h6>
                        </div>
                        <div className="d-flex align-items-center flex-wrap">
                            <div>Max Return Row to screen</div>
                            <div>{mapData(limitResult)} </div>
                        </div>
                        <>
                            <div className="d-flex align-items-center flex-wrap">
                                <h5>DataFilter</h5>
                            </div>
                            <div className="d-flex align-items-center flex-wrap">
                                {mapData({
                                    formik: formik,
                                    data: dataFilterFields,
                                })}
                            </div>
                        </>
                    </>
                )}
                {formik?.values?.report ===
                    'closed_auction_completion_report' && (
                    <div>
                        <div className="reportAction d-flex align-items-center">
                            <div className="row ">{mapData(sortSelect)}</div>
                        </div>
                        <div className="row ">{mapData(reportNameField)}</div>
                    </div>
                )}
                {formik.values.report === 'transaction_reconcile' ||
                formik.values?.report ==
                    'transaction_reconcile_transaction_reconciliation' ? (
                    <div className="reportAction d-flex align-items-center flex-wrap">
                        {/* <div className="reportLabel">
                            <h6>{t('Select Auction')}</h6>
                        </div> */}
                        <div className="d-flex flex-wrap">
                            <div className=" row d-flex justify-content-center align-items-center">
                                {mapData(auctionRange)}
                            </div>
                        </div>
                        {/* <div className="row">
                            {Object.values(mapData(template))}
                        </div> */}
                    </div>
                ) : null}
                <div className="reportAction d-flex align-items-center flex-wrap">
                    <div className="reportLabel">
                        <h6>{t('Search')}</h6>
                    </div>
                    <div className="d-flex flex-wrap">
                        <div className="d-flex justify-content-center align-items-center">
                            <RadioBox
                                items={allSearchOptions}
                                value={formik.values.search}
                                onChange={formik.handleChange}
                                name="search"
                            />
                        </div>
                        <div className="reportRange datePicker d-flex align-items-center">
                            {formik.values.search === 'within' ? (
                                <>
                                    <div className="row">
                                        {Object.values(mapData(withinRange))}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="row">
                                        {Object.values(mapData(dateRange))}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="reportAction d-flex align-items-center flex-wrap">
                    <div className="reportLabel">
                        <h6>{t('Order Results')}</h6>
                    </div>
                    <div className="orderResults d-flex justify-content-center align-items-center">
                        <RadioBox
                            items={allSortOptions}
                            value={formik.values.order}
                            onChange={formik.handleChange}
                            name="order"
                        />
                    </div>
                </div>{' '}
                <div className="d-flex align-items-center flex-wrap">
                    <div>Limits Results</div>
                    <div>{mapData(limitResult)} </div>
                </div>
                {formik?.values?.report === 'transaction_reconcile' ? (
                    <div className="row">
                        {Object.values(mapData(template))}
                    </div>
                ) : null}
                {isLoading && <div>Loading...</div>}
                <div className="actionButton d-flex  flex-wrap">
                    <PrimaryButton
                        id="report_generate"
                        type="submit"
                        label={t('Generate Report')}
                    />
                    {isTemplate ? (
                        <SecondaryButton
                            id="report_add"
                            onClick={() => {
                                generateReport('template')
                            }}
                            btnSize="ml-2"
                            // type="submit"
                            label={
                                formik.values.template
                                    ? t('Save Template')
                                    : t('Add Template')
                            }
                        />
                    ) : null}{' '}
                    {!isTemplate && templateId > 0 ? (
                        <>
                            {formik.values?.report !=
                            'transaction_reconcile_transaction_reconciliation' ? (
                                <>
                                    {' '}
                                    <SecondaryButton
                                        id="report_delete"
                                        btnSize="ml-2"
                                        onClick={() => {
                                            deleteReportTemplate({
                                                id: templateId,
                                            })
                                        }}
                                        // type="submit"
                                        label={t('Delete Template')}
                                    />
                                    <SecondaryButton
                                        id="report_update"
                                        btnSize="ml-2"
                                        onClick={() => {
                                            updateTemplate()
                                        }}
                                        // type="submit"
                                        label={t('Update Template')}
                                    />
                                </>
                            ) : null}
                        </>
                    ) : null}
                </div>
            </form>
        </div>
    )
}

export default ReportComponent
